import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import AddApp from '@/assets/icons/AddApp';
import { GX_TEXT } from '@/config/colors';
import { ButtonsContainer } from '@/features/dashboard/components/Drawer/components/ButtonsContainer';
import {
  DrawerStep,
  useDrawerSteps
} from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { DashboardStep } from '@/features/dashboard/constants/DashboardStep';
import { DASHBOARD_ACTION_BUTTON_WIDTH } from '@/features/dashboard/constants/style';
import { useDashboardEditLockContext } from '@/features/dashboard/state/DashboardEditLockContext';
import Button from '@/shared/ui/primitives/Button';

export const DashboardActionButtons = ({
  setStep,
  hideEditButton = false,
  children
}: {
  setStep: (step: DashboardStep) => void;
  /** Hides the Edit button. Used for the new-dashboard creation flow, where
   * there is nothing yet to edit. */
  hideEditButton?: boolean;
  children?: React.ReactNode;
}) => {
  const { setDrawerStep } = useDrawerSteps();
  const { requestEditLock } = useDashboardEditLockContext();

  const handleAddApp = () => {
    requestEditLock(() => {
      setDrawerStep(DrawerStep.SelectApp);
    });
  };

  return (
    <ButtonsContainer>
      {children}
      {!hideEditButton && (
        <Button
          color='secondary'
          size='large'
          startIcon={<EditOutlinedIcon />}
          sx={{
            width: DASHBOARD_ACTION_BUTTON_WIDTH
          }}
          variant='contained'
          onClick={() => setStep(DashboardStep.Edit)}
        >
          Edit
        </Button>
      )}
      <Button
        color='secondary'
        size='large'
        startIcon={<AddApp fill={GX_TEXT} />}
        sx={{
          width: DASHBOARD_ACTION_BUTTON_WIDTH
        }}
        variant='contained'
        onClick={handleAddApp}
      >
        Add app
      </Button>
    </ButtonsContainer>
  );
};
